// eslint-disable-next-line import/no-anonymous-default-export
export default {
  l10n: {
    date: {
      months: {
        full: [
          'janeiro',
          'fevereiro',
          'março',
          'abril',
          'maio',
          'junho',
          'julho',
          'agosto',
          'setembro',
          'outubro',
          'novembro',
          'dezembro',
        ],
        abbr: [
          'jan.',
          'fev.',
          'mar.',
          'abr.',
          'mai.',
          'jun.',
          'jul.',
          'ago.',
          'set.',
          'out.',
          'nov.',
          'dez.',
        ],
      },
      days: {
        full: [
          'domingo',
          'segunda-feira',
          'terça-feira',
          'quarta-feira',
          'quinta-feira',
          'sexa-feira',
          'sábado',
        ],
        abbr: ['dom.', 'seg.', 'ter.', 'qua.', 'qui.', 'sex.', 'sá.'],
      },
      patterns: {
        longDate: 'dddd, D MMMM YYYY',
        dateSlash: 'DD/MM/YYYY',
        dateShort: 'dddd D MMMM',
        dateShortWithDay: 'Do MMMM YYYY',
        dateMedium: 'dddd D MMMM - H[:]mm [h]',
        dateMediumReversed: 'H[:]mm - D MMMM YYYY',
        dateMediumSlash: 'DD[/]MM[/]YYYY [a las] H[:]mm',
        dateLarge: 'dddd D MMMM [a las] HH[:]mm [h]',
        timeShort: 'LT',
        timeMedium: 'DD[/]MM LT',
      },
    },
    number: {
      patterns: {
        standard: ['-n', 'n'],
        amount: ['-nS', 'nS'],
      },
      group: {
        separator: '.',
        length: 3,
        abbr: ['', 'k', 'M', 'B'],
      },
      decimal: {
        separator: ',',
        length: 2,
      },
      ordinal: function (number) {
        return number + (number === 1 ? '°' : '°');
      },
    },
  },
  translations: {
    messages: {
      Cart: [null, 'Carrinho'],
      Favourites: [null, 'Favoritos'],
      Delivery: [null, 'Entregas'],
      Summary: [null, 'Resumo'],
      Order: [null, 'Encomenda'],
      Categories: [null, 'Categorias'],
      'No results found': [null, 'Sem resultados'],
      'No favourites': [null, 'Nenhum favorito'],
      'Empty cart': [null, 'Carrinho vazio'],
      'No order': [null, 'Sem encomenda'],
      'Add to cart': [null, 'Adicionar ao carrinho'],
      Included: [null, 'Incluído'],
      Delete: [null, 'Eliminar'],
      Items: [null, 'Artigos'],
      Description: [null, 'Descrição'],
      Quantity: [null, 'Quantidade'],
      Price: [null, 'Preço'],
      'Where would you like to receive your order?': [
        null,
        'Onde deseja receber a sua encomenda?',
      ],
      Address: [null, 'Morada'],
      'Address details': [null, 'Endereço adicional'],
      'Estimated delivery date': [null, 'Data de entrega estimada'],
      'Confirm delivery': [null, 'Confirmar envio'],
      Form: [null, 'Formulário'],
      'Winamax account address': [null, 'Morada da sua conta Winamax'],
      'Other address': [null, 'Outra morada'],
      'Please select an address in Europe': [
        null,
        'Por favor, selecione um endereço na Europa',
      ],
      'Search an address': [null, 'Encontre um endereço'],
      'Please complete required fields': [
        null,
        'Por favor preencha os campos obrigatórios',
      ],
      'Enter your personal information': [
        null,
        'Introduza as suas informações pessoais',
      ],
      'Address 2': [null, 'Morada 2'],
      Postcode: [null, 'Código postal'],
      City: [null, 'Cidade'],
      'Telephone number': [null, 'Número de telefone'],
      'I agree for my account to be debited': [
        null,
        'Aceito que a minha conta seja debitada',
      ],
      Confirmation: [null, 'Confirmação'],
      Save: [null, 'Guardar'],
      'View order': [null, 'Ver pedido'],
      'Back to the shop': [null, 'Voltar à loja'],
      Orders: [null, 'Encomendas'],
      Pay: [null, 'Pagamento'],
      'Thank you': [null, 'Obrigado'],
      'We have received your order': [null, 'Recebemos o seu pedido'],
      'You will receive a confirmation e-mail shortly': [
        null,
        'Irá receber um email de confirmação em breve',
      ],
      'In progress': [null, 'A processar'],
      Completed: [null, 'Termninada'],
      'Order status': [null, 'Estado da minha encomenda'],
      'Contact support': [null, 'Contactar Suporte'],
      'Track order': [null, 'Seguir encomenda'],
      'Order date': [null, 'Data da encomenda'],
      'Order number': [null, 'Número da encomenda'],
      Sort: [null, 'Ordenar'],
      Miles: [null, 'Milhas'],
      'View results': [null, 'Ver resultados'],
      Recommended: [null, 'Recomendados'],
      'Price ascending': [null, 'Preço ascendente'],
      'Price descending': [null, 'Preço descendente'],
      'Show only products I can buy': [
        null,
        'Mostrar apenas produtos que posso comprar',
      ],
      Under: [null, 'Menos de'],
      Over: [null, 'Mais de'],
      Validate: [null, 'Validar'],
      Cancel: [null, 'Cancelar'],
      'Confirm cancellation': [null, 'Confirmar cancelamento'],
      'Are you sure you want to delete this item?': [
        null,
        'Tem a certeza que quer eliminar este elemento?',
      ],
      'Product added to favorites': [
        null,
        'Produto adicionado aos seus favoritos',
      ],
      'Product added to cart': [null, 'Produto adicionado ao carrinho'],
      See: [null, 'Ver'],
      'PRICE CHANGE': [null, 'ALTERAÇÃO DE PREÇO'],
      'The price of the %1$s product has changed. It will be adjusted in your cart.':
        [
          null,
          'O preço do produto foi alterado. Este será ajustado no seu carrinho',
        ],
      'QUANTITY UNAVAILABLE': [null, 'Quantidade disponível'],
      'We are sorry, the %1$s product is no longer available in the quantity you selected.':
        [
          null,
          'Lamentamos, o produto %1$s não se encontra disponível na quantidade que selecionou',
        ],
      'Product unavailable': [null, 'Produto não disponível'],
      'We are sorry, the %1$s product is no longer available. It will be removed from your cart.':
        [
          null,
          'Lamentamos, o produto %1$s não se encontra disponível e será eliminado do seu carrinho',
        ],
      Phone: [null, 'Telefone'],
      All: [null, 'Tudo'],
      Maintenance: [null, 'Manutenção'],
      Fitting: [null, 'Fitting'], // This is not translated, as "Fitting" might have different meanings. You might want to provide a context or use a Portuguese equivalent based on the context.
      Manufacturer: [null, 'Fabricação'],
      Back: [null, 'Voltar'],

      // ORDER STATUS
      'Order ready for delivery': [null, 'Encomenda pronta para envio'],
      'Order being prepared': [null, 'Encomenda em preparação'],
      'Order in process': [null, 'Encomenda em processamento'],
      'Order being delivered': [null, 'Encomenda em distribuição'],
      'This order requires some action on your part': [
        null,
        'A encomenda necessita da sua intervenção',
      ],
      'Order being processed manually': [
        null,
        'A encomenda está a ser tratada manualmente',
      ],
      'Order completed': [null, 'Encomenda concluída'],
      'Order returned': [null, 'Encomenda devolvida'],
      'Order cancelled': [null, 'Encomenda cancelada'],
      'Order resubmitted': [null, 'Encomenda reiniciada'],
      'Order refunded': [null, 'Encomenda reembolsada'],

      // CART ERRORS
      IMPORTANT: [null, 'ATENÇÃO'],
      'Some products could not be ordered due to %1$s. \n You can find them in your cart.':
        [
          null,
          'Não foi possível enviar alguns produtos devido a %1$s. \n Poderá encontrá-los no seu carrinho.',
        ],
      CONFIRM: [null, 'CONFIRMAR'],
      'Unable to order': [null, 'Não é possível encomendar'],
      'Your order could not be completed because of %1$s': [
        null,
        'A sua encomenda não pôde ser processada devido %1$s.',
      ],
      'Your order could not be completed': [
        null,
        'A sua encomenda não pôde ser concluída',
      ],
      'Back to cart': [null, 'Voltar ao carrinho'],

      // DEBIT MILES ERRORS
      'an identical order in progress': [
        null,
        'outra encomenda idêntica em curso',
      ],
      'The gift recipient could not be found': [
        null,
        'Não foi possível encontrar o destinatário da oferta',
      ],
      'a technical error': [null, 'um problema técnico'],
      'an error in the recipient of the bonus': [
        null,
        'um erro acerca do destinatário do bónus',
      ],
      'an insufficient Miles balance': [
        null,
        'um saldo de milhas insuficiente',
      ],
      'a deposit limit reached on your account': [
        null,
        'um limite de depósito atingido na sua conta',
      ],
      'You cannot offer this product to this player': [null, 'O produto não pode ser oferecido a este jogador'],

      // ADDITIONAL TRANSLATIONS
      'Log in to order': [null, 'Iniciar sessão'],
      'Delete all filters': [null, 'Reiniciar todos os filtros'],
      Materials: [null, 'Materiais'],
      'Next availability': [null, 'Próxima disponibilidade'],
      'All categories': [null, 'Ver tudo'],
      Filters: [null, 'Filtrar'],
      'See all': [null, 'Ver tudo'],
      'Check Details': [null, 'Ver detalhes'],
      'Place Order': [null, 'Encomendar'],
      'Enter a nickname': [null, 'Introduza um nome de utilizador'],
      'Your order will be shipped in multiple shipments': [
        null,
        'A sua encomenda será enviada em várias remessas',
      ],
      Offer: [null, 'Oferta'],
      View: [null, 'Ver'],
      'Express order': [null, 'Encomenda expresso'],
      Buy: [null, 'Comprar'],
      'Not enough miles. Please remove some items.': [
        null,
        'Milhas insuficientes. Por favor, remova alguns itens.',
      ],
      'Not enough miles available for immediate order': [
        null,
        'Não há milhas suficientes disponíveis para encomenda imediata',
      ],
      'Place order': [null, 'Encomendar'],
      Confirm: [null, 'Confirmar'],
      'Empty Cart': [null, 'Esvaziar o carrinho'],
      'Please select colors and/or size': [
        null,
        'Por favor, selecione cores e/ou tamanho',
      ],
      'Dematerialized product': [null, 'Produto desmaterializado'],
      Message: [null, 'Mensagem'],
      MILES: [null, 'MILHAS'],
    },
  },
};
